import { Injectable } from '@angular/core';
import { EnvService } from '../env.service';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Globals } from '../objects/Globals';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AttachmentService {
  private loginUrl: string;
  
  constructor(private env: EnvService, private http:HttpClient, private globals:Globals) { this.loginUrl = this.env.servicePath }

  uploadAttachment(cardId:string, propId:string, fileName:string, data, columnName: string = ""){
    var path = this.loginUrl +"UploadFile/"+cardId+"/"+propId+"?filename="+fileName + "&columnName=" + columnName;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'multipart/form-data', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, data, httpOptions);
  }

  getAttachmentList(cardId:string, propId:string, columnName: string = ""){
    var path = this.loginUrl +"GetFileList/"+cardId+"/"+propId + "?columnName=" + columnName;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json','Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  getMaximumFileUploadSize(): Observable<string>{
    var path = this.loginUrl +"GetMaximumFileUploadSize";
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json','Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  getAllowedFileTypes(): Observable<string>{
    var path = this.loginUrl +"GetAllowedFileTypes";
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json','Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  downloadFile(attachmentId:string):Observable<Blob>{
    var path = this.loginUrl +"DownloadFile/"+attachmentId;
    var httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({ 'Content-Type': 'application/json','Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<Blob>(`${path}`, httpOptions);
  }

  getFileName(attachmentId:string): Observable<string>{
    var path = this.loginUrl +"GetFileName/"+attachmentId;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json','Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  deleteFile( attachmentId:string, cardId:string, propertyId:string, columnName: string = ""){
    var path = this.loginUrl +"DeleteFile/"+attachmentId+"/"+cardId+"/"+propertyId + "?columnName=" + columnName;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json','Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, '', httpOptions);
  }

  deleteAllFile( attachmentIds:string[], cardId:string, propertyId:string){
    var path = this.loginUrl +"DeleteAllFile/" + cardId + "/" + propertyId;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text','Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, attachmentIds, httpOptions);
  }
}
